import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import useListRole from "../../role/ListRole/useListRole"
import axiosInstance from "../../../../services/axios-client"

const useUserForm = () => {
    const navigate = useNavigate()
    const { getRoles } = useListRole()
    const [roles, setRoles] = useState([])
    const [businessUnits, setBu] = useState([])
    const [isLoadingUser, setIsLoadingUser] = useState(false)
    const [payload, setPayload] = useState({
        ID: '',
        Email: "",
        Name: "",
        Nik: "",
        DateOfBirth: null,
        SupervisorNik: undefined,
        BusinessUnitId: undefined,
        OrganizationUnit: "",
        Division: "",
        Position: "",
        Department: "",
        JoinDate: null,
        Grade: "",
        Roles: [],
        ScoringMethod: undefined,
        PhoneNumber: "",
        AdditionalInfo: ""
    })
    const [scoringMethod, setScoringMethod] = useState([
        { label: 'Rating', value: 'Rating' },
        { label: 'Score', value: 'Score' },
    ])

    const onChangeHandler = (e) => {
        setPayload({ ...payload, [e.target.name]: e.target.value })
    }

    const handleSelectBusinessUnit = (value) => {
        setPayload({
            ...payload,
            BusinessUnitId: value
        })
    }

    const handleSelectRole = (value) => {
        setPayload({
            ...payload,
            Roles: value
        })
    }

    const handleSelectScoringMethod = (value) => {
        setPayload({
            ...payload,
            ScoringMethod: value
        })
    }

    const setListRoles = async () => {
        let data = await getRoles()
        let roles = []
        for (const role of data) {
            roles.push({
                'label': role.Name,
                'value': role.ID
            })
        }
        setRoles(roles)
    }

    const [allUsers, setAllUsers] = useState()
    const [userValue, setUserValue] = useState()

    const handleSelectedSupervisor = (value) => {
        setPayload({
            ...payload,
            SupervisorNik: value
        })
    }

    const getAllUsers = async () => {
        try {
            let res = await axiosInstance.get('/auth/users/all')
            if (res.status === 200) {
                let data = {}
                setAllUsers([])
                for (const user of res.data.data) {
                    setAllUsers((prev) => [...prev, {
                        'label': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName,
                        'value': user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName
                    }])
                    data[user.Nik + " " + user.Name + " " + user.Division + " - " + user.BusinessUnitName] = user.ID
                }
                setUserValue(data)

            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const setListBu = async () => {
        try {
            let res = await axiosInstance.get('/auth/business-units/all')
            if (res.status === 200) {
                let BUs = []
                for (const bu of res.data.data) {
                    BUs.push({
                        'label': bu.Name,
                        'value': bu.ID
                    })
                }
                setBu(BUs)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postUserForm = async (e) => {
        e.preventDefault()
        try {
            let data = { ...payload }
            if (data.DateOfBirth) {
                data.DateOfBirth = new Date(data.DateOfBirth).toISOString()
            }
            if (data.JoinDate) {
                data.JoinDate = new Date(data.JoinDate).toISOString()
            }
            if (userValue && data.SupervisorNik) {
                data.SupervisorNik = userValue[data.SupervisorNik]
            }
            let res = await axiosInstance.post('/auth/users', data)
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Create User")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const putUserForm = async (e) => {
        e.preventDefault()
        try {
            let data = { ...payload }
            if (data.DateOfBirth) {
                data.DateOfBirth = new Date(data.DateOfBirth).toISOString()
            }
            if (data.JoinDate) {
                data.JoinDate = new Date(data.JoinDate).toISOString()
            }
            if (userValue && data.SupervisorNik) {
                data.SupervisorNik = userValue[data.SupervisorNik]
            }
            let res = await axiosInstance.put('/auth/users', data)
            if (res.status === 200) {
                navigate(-1)
                toast.success("Success Update User")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const getUserForm = async (id) => {
        try {
            setIsLoadingUser(true)
            let res = await axiosInstance.get(`/auth/users/${id}`)
            if (res.status === 200) {
                let roles = []
                for (const role of res.data.data.Roles) {
                    roles.push(role.ID)
                }

                const formattedDateBod = res.data.data.DateOfBirth
                    ? new Date(res.data.data.DateOfBirth).toISOString().split('T')[0]
                    : "";
                const formattedHireDate = res.data.data.JoinDate
                    ? new Date(res.data.data.JoinDate).toISOString().split('T')[0]
                    : "";

                let supervisor = " "
                if (userValue && res.data.data.SupervisorNik) {
                    supervisor = Object.keys(userValue).find(key => userValue[key] === res.data.data.SupervisorNik)
                }
                setPayload({
                    ID: res.data.data.ID,
                    Email: res.data.data.Email,
                    Name: res.data.data.Name,
                    Nik: res.data.data.Nik,
                    DateOfBirth: formattedDateBod,
                    SupervisorNik: supervisor,
                    BusinessUnitId: res.data.data.BusinessUnitId,
                    OrganizationUnit: res.data.data.OrganizationUnit,
                    Division: res.data.data.Division,
                    Department: res.data.data.Department,
                    Position: res.data.data.Position,
                    JoinDate: formattedHireDate,
                    Grade: res.data.data.Grade,
                    Roles: roles,
                    ScoringMethod: res.data.data.ScoringMethod,
                    PhoneNumber: res.data.data.PhoneNumber,
                    AdditionalInfo: res.data.data.AdditionalInfo
                })
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsLoadingUser(false)
        }
    }

    return {
        setListBu,
        businessUnits,
        setListRoles,
        roles,
        postUserForm,
        putUserForm,
        getUserForm,
        payload,
        onChangeHandler,
        handleSelectBusinessUnit,
        handleSelectRole,
        scoringMethod,
        handleSelectScoringMethod,
        allUsers,
        userValue,
        getAllUsers,
        handleSelectedSupervisor,
        isLoadingUser
    }
}

export default useUserForm